import React, { FC, memo, HTMLAttributes } from 'react';
import { Container, ContainerProps } from './styled';

type Props = ContainerProps & HTMLAttributes<HTMLDivElement>;

export const Tag: FC<Props> = memo(({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
));
